/**
 * Utilitários para disparar eventos customizados no Microsoft Clarity
 */

declare global {
  interface Window {
    clarity?: (...args: any[]) => void;
  }
}

/**
 * Registra uma ação customizada (evento) do usuário no Microsoft Clarity.
 * Use para botões clicados, formulários completados, erros de UX capturados, etc.
 * 
 * @param eventName O nome do evento (ex: "click_fale_conosco")
 */
export const trackClarityEvent = (eventName: string, tags?: Record<string, string | number | boolean | null | undefined>) => {
  if (typeof window !== "undefined" && window.clarity) {
    if (tags) {
      Object.entries(tags).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          window.clarity!("set", key, String(value));
        }
      });
    }
    window.clarity("event", eventName);
  }
};

/**
 * Atribui uma Tag (chave/valor) personalizada à gravação e sessão atual.
 * Ideal para marcar o ID do usuário, o tipo de plano que ele escolheu ou o estado atual da página.
 * 
 * @param key Chave da tag (ex: "tipo_usuario")
 * @param value Valor da tag (ex: "premium")
 */
export const setClarityTag = (key: string, value: string) => {
  if (typeof window !== "undefined" && window.clarity) {
    window.clarity("set", key, value);
  }
};
